import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getDomainDetail } from "./api";
import "./App.css";
import buttonImg from "./asset/img/button.png";
import textImg from "./asset/img/lastestWeb.png";

import {
  generateDeviceId,
  //generateTimeToken,
  getImgSrc, setFavicons
} from "./utils";

function App() {
  const [domainData, setDomainData] = useState({});
  const getDomainDetailData = async () => {
    const deviceId = await generateDeviceId();
    const res = await getDomainDetail(deviceId);
    const logo = res.data.data.logo;
    const logoSrc = await getImgSrc(logo);
    setFavicons(logoSrc);
    const title = res.data.data.title;
    var appTitle = document.querySelector("title");
    appTitle.innerHTML = title;
    // const { timeToken } = generateTimeToken()
    // const address = `${res.data.data.address}?token=${timeToken}`
    setDomainData({ ...res.data.data, logoSrc });
  };
  useEffect(() => {
    getDomainDetailData();
  }, []);

  const onCopy = () => {
    alert("复制成功！");
  };

  return (
    <div className="App">
      <div className="logo-container">
        <div className="logo">
          <img src={domainData.logoSrc} alt="logo" />
        </div>
        <div className="app-name">{domainData.app_name}</div>
      </div>

      <div>
        <div className="web-site">
          <img src={textImg} alt="" />
        </div>
        <div className="btn-container">
          <CopyToClipboard
            text={domainData.address}
            onCopy={onCopy}
          >
            <div className="copy-button">
              <img src={buttonImg} alt="" />
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
}

export default App;
